if (!customElements.get('sale-countdown')) {
  customElements.define(
    'sale-countdown',
    class SaleCountdown extends HTMLElement {
      connectedCallback() {
        window.clearInterval(this.interval);

        this.countdownValue = this.querySelector('[data-countdown-value]');
        this.startAt = this.parseDate(this.dataset.startAt);
        this.endAt = this.parseDate(this.dataset.endAt);

        if (!this.countdownValue || !this.endAt || (this.startAt && this.endAt <= this.startAt)) {
          this.setVisibility(false);
          return;
        }

        this.update();
        if (Date.now() < this.endAt) {
          this.interval = window.setInterval(() => this.update(), 1000);
        }
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      parseDate(value) {
        if (!value) return null;

        const timestamp = Date.parse(value);
        return Number.isNaN(timestamp) ? null : timestamp;
      }

      setVisibility(visible) {
        this.hidden = !visible;
        const countdownOnlyContainer = this.closest('[data-countdown-only]');

        if (countdownOnlyContainer) {
          countdownOnlyContainer.hidden = !visible;
        }
      }

      update() {
        const now = Date.now();

        if ((this.startAt && now < this.startAt) || now >= this.endAt) {
          this.setVisibility(false);

          if (now >= this.endAt) {
            window.clearInterval(this.interval);
          }
          return;
        }

        this.setVisibility(true);

        const remainingSeconds = Math.max(0, Math.floor((this.endAt - now) / 1000));
        const days = Math.floor(remainingSeconds / 86400);
        const hours = Math.floor((remainingSeconds % 86400) / 3600);
        const minutes = Math.floor((remainingSeconds % 3600) / 60);
        const seconds = remainingSeconds % 60;

        this.countdownValue.textContent = `${days}d ${hours}h ${minutes}m ${seconds}s`;
      }
    }
  );
}
